/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentPersonCourseViewModel } from "../types/IndividualPaymentPersonCourseViewModel.ts";

export const individualPaymentPersonCourseViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  main: z.optional(z.boolean()),
  creationDate: z.string().datetime().nullish(),
  courseRegistrationId: z.optional(z.number().int()),
  courseRegistrationStatus: z.optional(z.number().int()),
  courseRegistrationStatusText: z.string().nullish(),
  scholarshipStatusText: z.string().nullish(),
  personId: z.optional(z.number().int()),
  description: z.string().nullish(),
  courseName: z.string().nullish(),
  typeText: z.string().nullish(),
  paymentMethod: z.string().nullish(),
  isUSP: z.optional(z.boolean()),
  statusId: z.optional(z.number().int()),
  status: z.string().nullish(),
  poloId: z.number().int().nullish(),
  poloName: z.string().nullish(),
  totalValue: z.number().nullish(),
}) as unknown as ToZod<IndividualPaymentPersonCourseViewModel>;
